"use strict";

import "./Details.css";
import React from "react";
import classnames from "classnames";

import Tabs from "vwa/components/Tabs";
import Button from "vwa/components/Button";
import ReactDOM from "react-dom";

export default class Details extends React.Component{
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = {
			title: this.props.title,
			activeTab: (this.props.activeTab || (this.props.tabs ? this.props.tabs[0].id : null))
		}
	}
	
	componentWillReceiveProps(nextProps){
		this.setState({
			title: nextProps.title,
			tabs: nextProps.tabs,
			activeTab: nextProps.activeTab
		});
	}
	
	renderTabs(){
		const tabItems = this.props.tabs.map( tabs => {return(<li id={tabs.id} key={tabs.id}>{tabs.label}</li>)} );
		
		return(
			<Tabs onChange={this.props.onTabChange}  className="Light" selected={this.state.activeTab}>
				{ tabItems }
			</Tabs>
		)
	}
	
	handleDragEvent(evt){
		this.props.ondrag(evt);
	}
	
	componentDidMount(){
		if(this.props.dragable){
			const dragButton = ReactDOM.findDOMNode(this.refs.dragButton);
			dragButton.addEventListener("drag", evt => this.handleDragEvent(evt));
		}
	}
	
	renderDragButton(){
		if(this.props.dragable){
			return(
				<Button icon="unfold-more" draggable="true" ref="dragButton" />
			)
		}
	}
	
	renderCloseButton(){
		if(this.props.closable){
			return(
				<Button icon="close" onClick={this.props.onClose} />
			)
		}
	}
	
	renderControlButtons(){		
		return(
			<div className={"ButtonContainer"}>
				{this.renderDragButton()}
				{this.renderCloseButton()}
			</div>
		)
	}
	
	render(){
		return (
			<div className={classnames(this.props.className, "Details")}>
				<header>
					<h1>{this.state.title}</h1>
					{this.renderTabs()}
					{this.renderControlButtons()}
				</header>
				<div className="Content">
					{this.props.children}
				</div>
			</div>
		);
		
	}
	
}

Details.propTypes = {
	title: React.PropTypes.string,
	closable: React.PropTypes.bool,
	onClose: React.PropTypes.func,
	tabs: React.PropTypes.arrayOf(React.PropTypes.shape({label: React.PropTypes.string, id: React.PropTypes.string})),
	onTabChange: React.PropTypes.func,
	activeTab: React.PropTypes.string,
	dragable: React.PropTypes.bool,
	ondrag: React.PropTypes.func
};

Details.defaultProps = {
	title: "",
	closable: true,
	onClose: () => {},
	onTabChange: page => {},
	dragable: false,
	ondrag: evt => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/Details/Details.jsx